if (!customElements.get('mobile-dock')) {
  customElements.define(
    'mobile-dock',
    class MobileDock extends BaseElement {
      connectedCallback() {
        super.connectedCallback();
    
        if (Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get section() {
        return this._section = this._section || this.closest('.mobile-dock-section');
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        this.setAttribute('loaded', '');
    
        this.detectForHeader();
        this.detectForFooter();
        this.initCoverageDrawers();
        setTimeout(this.setHeight.bind(this));
        this.on(document, 'matchSmall', this.setHeight.bind(this));
    
        if (Shopify.designMode) {
          this.on(this.section, 'shopify:section:select', () => {
            this.section.classList.add('shopify-active');
          });
          this.on(this.section, 'shopify:section:deselect', () => {
            this.section.classList.remove('shopify-active');
          });
        }
      }


      initCoverageDrawers() {
        const triggers = this.querySelectorAll('[data-mobile-dock-coverage-trigger]');
        triggers.forEach((trigger) => {
          trigger.addEventListener('click', (event) => {
            const existingCoverage = document.querySelector('.tcv[id^="tcv-"]');
            const onCoveragePage = window.location.pathname.replace(/\/$/, '') === '/pages/vehicle-coverage';
            if (onCoveragePage && existingCoverage) {
              event.preventDefault();
              event.stopImmediatePropagation();
              (existingCoverage.querySelector('.tcv__finder') || existingCoverage).scrollIntoView({ behavior: 'smooth', block: 'start' });
              return;
            }

            const drawerId = trigger.getAttribute('aria-controls');
            const drawer = drawerId ? document.getElementById(drawerId) : null;
            if (drawer) this.loadCoverageDrawer(drawer);
          }, { capture: true });
        });
      }

      loadCoverageDrawer(drawer) {
        const mount = drawer.querySelector('[data-mobile-dock-coverage-mount]');
        const frame = mount?.querySelector('[data-mobile-dock-coverage-frame]');
        const loading = mount?.querySelector('[data-coverage-frame-loading]');
        if (!mount || mount.dataset.state === 'loaded' || mount.dataset.state === 'loading') return;

        const requestUrl = new URL(
          frame?.dataset.coverageSectionUrl || mount.dataset.coverageSectionUrl,
          window.location.origin
        );
        if (!requestUrl.searchParams.get('preview_theme_id')) {
          requestUrl.searchParams.set('preview_theme_id', '187049738543');
        }
        ['preview_theme_id', 'preview_token', '_cd'].forEach((key) => {
          const value = new URLSearchParams(window.location.search).get(key);
          if (value) requestUrl.searchParams.set(key, value);
        });

        mount.dataset.state = 'loading';
        const showError = (message) => {
          mount.dataset.state = 'error';
          mount.innerHTML = `
            <div class="mobile-dock-coverage-drawer__error" role="alert">
            <strong>Vehicle coverage could not load.</strong>
            <p>${message}</p>
            <button type="button" data-coverage-retry>Try again</button>
            </div>`;
          mount.querySelector('[data-coverage-retry]')?.addEventListener('click', () => {
            mount.dataset.state = '';
            mount.innerHTML = '<div class="mobile-dock-coverage-drawer__loading" data-coverage-frame-loading role="status" aria-live="polite"><span class="mobile-dock-coverage-drawer__spinner" aria-hidden="true"></span><strong>Loading vehicle coverage…</strong></div>';
            this.loadCoverageDrawer(drawer);
          }, { once: true });
        };

        fetch(requestUrl.toString(), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Coverage request failed (${response.status})`);
            return response.text();
          })
          .then((html) => {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const finderRoot = parsed.querySelector('.tcv[id^="tcv-"]');
            const renderedSection = finderRoot?.closest('.shopify-section') || finderRoot;
            if (!renderedSection?.querySelector('.tcv__finder')) {
              throw new Error('The coverage finder was not returned.');
            }

            const scripts = Array.from(renderedSection.querySelectorAll('script:not([type="application/json"])'));
            scripts.forEach((script) => script.remove());
            mount.replaceChildren(document.importNode(renderedSection, true));

            scripts.forEach((oldScript) => {
              const script = document.createElement('script');
              Array.from(oldScript.attributes).forEach((attribute) => {
                script.setAttribute(attribute.name, attribute.value);
              });
              script.textContent = oldScript.textContent;
              mount.appendChild(script);
            });

            const finder = mount.querySelector('.tcv__finder');
            if (!finder) throw new Error('The coverage finder could not initialize.');
            mount.dataset.state = 'loaded';
            mount.setAttribute('data-coverage-section-lazy-loaded', 'true');
          })
          .catch((error) => {
            console.error('[Mobile dock coverage]', error);
            showError('Please check your connection and try again.');
          });
      }

      detectForHeader() {
        const header = document.querySelector('.header-section');
        if (header === null) {
          this.section.classList.add('active');
          return;
        }
        
        if (!header.classList.contains('header-sticky')) {
          this.scrollY = parseInt(header.getBoundingClientRect().bottom + window.scrollY);
          const onScroll = theme.utils.throttle(this.onScrollForHeader.bind(this));
          this.on(window, 'scroll', onScroll, { passive: true });
          this.registerCleanup(() => onScroll.cancel());
        }
      }
    
      onScrollForHeader() {
        if (window.scrollY >= this.scrollY) {
          this.section.classList.add('active');
        }
        else {
          this.section.classList.remove('active');
        }
      }
    
      detectForFooter() {
        const footer = document.querySelector('.footer-copyright');
        if (footer === null) return;
    
        const onScroll = theme.utils.throttle(this.onScrollForFooter.bind(this));
        this.on(window, 'scroll', onScroll, { passive: true });
        this.registerCleanup(() => onScroll.cancel());
      }
    
      onScrollForFooter() {
        if (!theme.config.mqlSmall) return;
        
        const scrolledTo = window.scrollY + window.innerHeight;
        const threshold = this.offsetHeight;
        const isReachBottom = document.body.scrollHeight - threshold <= scrolledTo;
        this.classList.toggle('active', isReachBottom);
      }
    
      setHeight() {
        document.documentElement.style.setProperty('--mobile-dock-height', `${this.getBoundingClientRect().height.toFixed(1)}px`);
      }
    }, { extends: 'nav' }
  );
}
